import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

const useSlugUrlRedirect = (isServer, category) => {
    const location = useLocation()

    const {shouldRedirect, redirectUrl} = useMemo(() => {
        if (!isServer || category?.c_canonicalUrl === undefined || category?.c_canonicalUrl === '')
            return {shouldRedirect: false}
        const slugUrl = new URL(
            category?.c_canonicalUrl.replace('/s/', '/'),
            // we only use pathname, so it doesn't matter what the origin is
            'https://www.stokke.com'
        )
        // location decodes unicode characters, so we need to encode them to compare with slugUrl
        const locationUrl = new URL(
            location.pathname,
            // we only use pathname, so it doesn't matter what the origin is
            'https://www.stokke.com'
        )

        const shouldRedirect = slugUrl.pathname !== locationUrl.pathname

        return {
            shouldRedirect,
            redirectUrl: slugUrl.pathname + location.search
        }
    }, [location?.pathname, location.search, category?.c_canonicalUrl, isServer])

    if (shouldRedirect) {
        return redirectUrl
    }
}

export default useSlugUrlRedirect
